import React from 'react';
import { Box } from '@mui/material';

import { TFullSender } from '../../store/users/users.types';
import SenderInfo from '../SenderInfo';
import { IMessage } from '../../store/types/Message.types';

export interface IGiftVideoMessageProps {
  message: IMessage;
  sender: TFullSender | null;
}

const GiftVideoMessage = ({ message, sender }: IGiftVideoMessageProps): JSX.Element => (
  <>
    <Box p={0}>
      <Box height={250}>
        <iframe
          width="100%"
          height="100%"
          data-testid="giftEmbedVideo"
          title="video-message"
          className="embed-responsive-item"
          src={message.content}
          frameBorder={0}
          allowFullScreen
        />
      </Box>
    </Box>
    <SenderInfo sender={sender} />
  </>
);

export default GiftVideoMessage;
